.banner {
	flex: none;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--space-2);
	padding: var(--space-2) var(--space-4);
	background: color-mix(in srgb, var(--ink-muted) 14%, var(--surface-page));
	border-bottom: 1px solid var(--border);
	color: var(--ink-muted);
	font-size: 0.8125rem;
	text-align: center;
}

.banner svg {
	flex: none;
}
